import { ReactNode } from 'react';
import { CORE_ROUTER_CONFIG } from '../../core/config/router/router';
import { ERP_ROUTER_CONFIG } from '../../erp/config/router/router';

export type RouteConfig = {
  path: string;
  element?: ReactNode;
  navigate?: string;
};

export type RoutesConfig = {
  auth: RouteConfig[];
  authNonAuth: RouteConfig[];
  admin: RouteConfig[];
  adminNonAuth: RouteConfig[];
};

export const ROUTER_CONFIG: RoutesConfig = {
  auth: [...CORE_ROUTER_CONFIG.auth, ...ERP_ROUTER_CONFIG.auth],
  authNonAuth: [
    ...CORE_ROUTER_CONFIG.authNonAuth,
    ...ERP_ROUTER_CONFIG.authNonAuth,
  ],
  admin: [...CORE_ROUTER_CONFIG.admin, ...ERP_ROUTER_CONFIG.admin],
  adminNonAuth: [
    ...CORE_ROUTER_CONFIG.adminNonAuth,
    ...ERP_ROUTER_CONFIG.adminNonAuth,
  ],
};
